import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    formSubtitle: {
        fontFamily: "Source Sans 3",
        fontWeight: 600,
        fontSize: "18px",
        color: theme.palette.secondary.dark,
        margin: "0 0 24px 0",
    },
    helperText: {
        fontFamily: "Source Sans 3",
        fontSize: "12px",
        color: theme.palette.secondary.dark,
    },
    checkboxList: {
        display: "grid !important",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: theme.spacing(2),
    },
    checkboxListLabel: {
        textAlign: "left",
    },
    checkbox: {
        "&.MuiCheckbox-root": {
            "&.Mui-checked": {
                color: theme.palette.info.light,
            },
        },
    },
    textField: {
        width: "100%",
        height: 56,
        marginBottom: "15px",
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    textFieldModal: {
        width: "100%",
        height: 40,
        marginBottom: "15px",
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            fontWeight: "400",
            height: "41px",
            "& input": {
                height: "41px",
                padding: "0 14px",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            fontWeight: "400",
            transform: "translate(14px, 11px) scale(1)",
            "&.MuiInputLabel-shrink": {
                transform: "translate(14px, -6px) scale(0.75)",
            },
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    listItem: {
        display: "flex",
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
    },
    keySuccessFactorlistItem: {
        display: "flex",
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    listContainer: {
        display: "grid !important",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: theme.spacing(4),
    },
    listCustomContainer: {
        display: "grid !important",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: theme.spacing(4),
    },
    listText: {
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            color: theme.palette.secondary.dark,
        },
    },
    listTextTitle: {
        width: 0,
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            color: theme.palette.secondary.dark,
            textTransform: "capitalize",
        },
    },
    contentCardContent: {
        padding: `${theme.spacing(4)} ${theme.spacing(8)} !important`,
    },
}));
